// export * from './staging.js'

// export * from './production.js'
export const API_HOST = process.env.REACT_APP_ENV === 'development' ? 
'https://dnnae-api-bdhweedyzq-uc.a.run.app' : 
'https://dnnae-api-prod-bdhweedyzq-uc.a.run.app'

// https://dnnae-api-bdhweedyzq-uc.a.run.app